import PropTypes from "prop-types";
import React, { useContext } from "react";

import { classNames } from "@swa-ui/string";

import "../../generated/platforms/scss/business-dark.module.scss";
import "../../generated/platforms/scss/business-light.module.scss";
import "../../generated/platforms/scss/business.module.scss";
import { DesignTokensThemeContext, DesignTokensThemeProvider } from "../DesignTokensThemeProvider";

/**
 * Default business theme.
 */

export const BusinessTheme = (props) => {
  const { children } = props;
  const { isDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  return <DesignTokensThemeProvider {...getProps()}>{children}</DesignTokensThemeProvider>;

  function getProps() {
    return {
      className: classNames(
        isDarkMode ? "business-dark-theme" : "business-light-theme",
        "business-theme"
      ),
      inverse: false,
      themeName: "business",
    };
  }
};

BusinessTheme.propTypes = {
  /** Content that will be rendered within the theme. */
  children: PropTypes.node,
};
